<div class="chat-container">
  <div
    class="messages-panel flex flex-column-reverse"
    [ngClass]="{ 'confirm-mode': isShowConfirm }"
    #infiniteScroll
    (scroll)="onScrollContainer($event)">
    <!-- TYPING -->
    @if (typingIndicator$ | async; as typingData) {
      <div class="message-container flex flex-row gap-1">
        <div class="avatar">
          <app-user-avatar
            [avatar]="typingData.avatar"
            [displayName]="typingData.displayName"
            [isChatbot]="typingData.displayName === 'Chatbot'" />
        </div>

        <div class="flex flex-column gap-1">
          <!-- content -->
          <div class="message-bubble">
            <div class="dot-container">
              {{ typingData.displayName || 'Someone' }} is typing<span
                class="dot"></span>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- MESSAGE -->

    <div class="flex-grow-1 flex flex-column-reverse justify-content-end">
      @for (message of listMessages; track message.id; let i = $index) {
        <app-chat-message
          [previousMessage]="listMessages[i + 1] || null"
          [message]="message"
          [isMine]="message.senderType === 'user'"
          [template]="message.id === -1 ? 'LOADING' : 'CONTENT'"
          [userPreferredLanguage]="userPreferredLanguage"
          class="app-chat-message-container"></app-chat-message>
      }
    </div>

    @if ((isLoadingMessage$ | async) || false) {
      <div class="content-progress-bar-notification">
        <span class="loader"></span>
      </div>
    }

    @if (showHasNewMessage && isScrollingUp) {
      <p-button
        data-cy="new-messages-button"
        label="New messages"
        class="custom-p-button custom-p-button--secondary btn-new-messages"
        (onClick)="onClickNewMessages()"></p-button>
    }
  </div>
  <div
    class="input-panel flex justify-content-end align-items-end pb-2 pt-2 gap-2">
    <div class="inbox-upload">
      <div class="icon cursor-pointer" (click)="selectFile()">
        <i class="pi pi-paperclip"></i>
      </div>
      <p-fileUpload
        #fileUploader
        accept=".pdf,.jpg, .jpeg, .png"
        [showUploadButton]="false"
        [showCancelButton]="false"
        [multiple]="true"
        [customUpload]="true"
        [style]="{ display: 'none' }"
        (onSelect)="onSelect($event)"></p-fileUpload>
    </div>
    <textarea
      pTextarea
      placeholder="Message..."
      class="inbox-content custom-p-input"
      maxlength="2000"
      [rows]="2"
      TextInputValidate
      [autoResize]="true"
      [(ngModel)]="messageInput"
      (focus)="onInputFocus()"
      (keypress)="onKeyPress($event)"
      (keyup)="onChange($event)"></textarea>
    <div style="padding: 0px; margin-bottom: 4px">
      <p-button
        data-cy="send-button"
        label="Send"
        class="custom-p-button custom-p-button--secondary small-button"
        [ngClass]="{
          'btn-disable':
            messageInput.length <= 0 ||
            messageInput.trim().length <= 0 ||
            (isLoadingMessage$ | async),
        }"
        [disabled]="
          messageInput.length <= 0 ||
          messageInput.trim().length <= 0 ||
          (isLoadingMessage$ | async)
        "
        (onClick)="onSend()"></p-button>
    </div>
  </div>
</div>
